import('./bootstrapper').then(({bootstrapper}) => {

    const v = bootstrapper.init({
        editmode: window.editmode || false
    });
    if(window.console) {
        console.log('app bootstrap - v' + v);
    }
});